export const getDate = (date) => {
  const current = new Date(parseInt(date));

  return current.toLocaleString();
};
